export default __webpack_public_path__ + "static/media/RightThumbSlider.8fcf85cb.svg";